import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { labelClassName } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

import { TestimonialPaginationSection } from './TestimonialPagination.style';

export const ButtonSlider: StyleRule = ({ theme }) => ({
    border: 'none',
    background: 'transparent',
    padding: 0,

    ':hover:enabled span': {
        background: theme.siteVariables.colors.charcoal[260],
    },

    ':disabled span': {
        background: theme.siteVariables.colors.charcoal[100],
    },
});

export const TestimonialSlideInner: StyleRule = ({ theme }) => ({
    width: pxToRem(590),
    minHeight: pxToRem(325),
    [theme.screen.laptop]: {
        display: 'flex',
    },
});

export const TestimonialSliderControls: StyleRule = ({ theme }) => ({
    bottom: pxToRem(60),
    right: pxToRem(4),
    marginTop: pxToRem(127),
    [theme.screen.laptop]: {
        bottom: pxToRem(186),
        right: pxToRem(109),
    },
});

export const TestimonialSlide = () => ({
    whiteSpace: 'normal',
    width: '100%',
    display: 'inline-block',
});

export const TestimonialSlider = () => ({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '100%',
});

export const TestimonialSlideMobile = () => ({
    whiteSpace: 'normal',
    display: 'inline-block',
    top: 0,
    position: 'relative',
});

export const TestimonialSliderPrev: StyleRule = ({ theme }) => ({
    height: pxToRem(48),
    width: pxToRem(48),

    margin: `0`,
    borderRadius: pxToRem(50),
    background: theme.siteVariables.colors.charcoal[250],
    [`&.${svgIconClassName}`]: {
        display: 'flex',
    },

    '> svg': {
        borderRadius: theme.siteVariables.borderRadiusXLarge,
        height: '100%',
        width: '50%',
        margin: 'auto',
        fill: theme.siteVariables.colors.white[300],
    },
    [theme.screen.laptop]: {
        height: pxToRem(48),
        width: pxToRem(48),
        cursor: 'pointer',
        margin: pxArrayToRem([0, 8]),
    },
});

export const TestimonialsWrapper: StyleRule = () => ({
    display: 'inherit',
    marginRight: pxToRem(-15),
});

export const TestimonialsWrapperMobile: StyleRule = ({
    multipleTestimonials,
}) => ({
    overflow: 'hidden',
    width: '100vw',
    display: 'inherit',
    marginBottom: multipleTestimonials ? 0 : pxToRem(24),
    padding: pxArrayToRem([0, 18]),

    '& .swiper-testimonial-pagination': {
        display: 'flex',
        justifyContent: 'center',
        marginTop: pxToRem(10),
        fontSize: pxToRem(14),
        position: 'relative',
        bottom: 0,
    },
    '& .swiper-pagination-current': {
        marginRight: pxToRem(4),
    },
    '& .swiper-pagination-total': {
        marginLeft: pxToRem(4),
    },

    '& .swiper-slide': {},
});

export const TestimonialsSwiperWrapper: StyleRule = () => ({
    overflow: 'hidden',
    width: '100%',
    '& div': {
        display: 'flex',
    },
    '& .swiper-slide': {
        height: 'unset',
    },
});

export const PaginationSpan: StyleRule = ({ theme }) => ({
    fontSize: theme.siteVariables.fontSizes.label02,
    width: pxToRem(50),
    height: pxToRem(48),
    paddingTop: pxToRem(12),
    borderRadius: 'unset',
    opacity: 1,
    background: 'transparent',

    '&:hover': {
        background: 'rgba(0, 0, 0, 0.06)',
    },
    display: 'inline-block',
    'text-align': 'center',
    '&.swiper-pagination-bullet-active': {
        borderBottom: `${pxToRem(2)} solid ${
            theme.siteVariables.colors.charcoal[250]
        }`,
        opacity: 1,
        background: 'transparent',
    },
});

export const ButtonBox: StyleRule = ({ theme }) => ({
    position: 'absolute',
    right: 0,
    marginRight: pxToRem(27),
    marginTop: pxToRem(-1),
    bottom: pxToRem(10),
    zIndex: theme.siteVariables.zIndexes.menuItem,
});

export const TestimonialHeader: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(134),
    fontWeight: theme.siteVariables.fontWeightRegular,
    letterSpacing: '-0.033em',
    marginBottom: pxToRem(133),
    marginTop: 0,
    marginLeft: pxToRem(-1),
});

export const TestimonialHeaderMobile: StyleRule = ({ theme }) => ({
    letterSpacing: '-0.01',
    ...theme.siteVariables.textStyles.Heading.Roman55,
    textTransform: 'uppercase',
    fontSize: theme.siteVariables.fontSizes.caption03,
    lineHeight: 1,
});

export const PaginationSection: StyleRule = () => ({
    ...TestimonialPaginationSection,
    '& > .swiper-pagination': {
        width: '50%',
    },
});

export const SlidePage: StyleRule = () => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridGap: pxToRem(25),
    '& > .swiper-slide:nth-child(3n-1)': {
        marginRight: pxToRem(9),
        marginLeft: pxToRem(8),
    },
});

export const ViewAllButton: StyleRule = () => ({
    textDecoration: 'underline',
    textUnderlineOffset: pxToRem(2),
    display: 'block',
    padding: pxToRem(7),
    paddingBottom: 0,
    textAlign: 'center',
    [`& > .${labelClassName}`]: {
        textDecoration: 'underline',
        textUnderlineOffset: pxToRem(2),
    },
});

export const TestiomnialSlideWrapper: StyleRule = () => ({
    marginTop: pxToRem(24),
    height: '100%',
});
